import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../../funcoes";
import { Global } from "../../global";

declare var PNotify: any;

export abstract class Components {

  protected abstract translate: TranslateService;
  protected abstract router: Router;
  abstract func: Funcoes;
  abstract global: Global;

  paginaAtual: number = 1;
  totalItens: number = 10;
  carregandoTabela = false;

  get itensPorPagina(): string {
    let val = localStorage.getItem('itensPorPagina');
    if (!val) {
      return '25';
    }
    let path = window.location.pathname;
    if (path !== '/painel/transportes' && path !== '/transportes' && !path.endsWith('/transportes') && (val === '500' || val === '1000')) {
      return '25';
    }
    return val;
  }

  set itensPorPagina(val: string) {
    localStorage.setItem('itensPorPagina', val);
  }

  constructor() { }

  // altera a quantidade de itens por pagina
  qtdItensPorPagina(event) {
    this.itensPorPagina = event.target.value;
    localStorage.setItem('itensPorPagina', event.target.value);
    this.getPage(1);
  }

  // busca a pagina
  getPage(pagina) { }

  // trata erros vindos do server
  trataErro(json) {
    if (this.global.debug == true) {
      console.log(json);
    }

    this.func.showErro(json.Message);
  }

  // salva o filtro no localStorage baseado na URL atual
  salvaFiltro(filtro) {
    localStorage.setItem('filtro_' + this.router.url, JSON.stringify(filtro));
  }

  // busca o filtro salvo no localStorage para a URL atual
  carregaFiltro() {
    let filtro = localStorage.getItem('filtro_' + this.router.url);
    return (filtro) ? JSON.parse(filtro) : null;
  }

  // remove o filtro salvo no localStorage para a URL atual
  limpaFiltroSalvo() {
    localStorage.removeItem('filtro_' + this.router.url);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/components.ts